import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation";

const HomeCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      className="relative z-10 bg-gradient-to-br from-brandBeige via-white to-[#E07A52]/20 px-4 py-11 sm:py-16"
      aria-labelledby="home-cta-heading"
    >
      <div className="mx-auto max-w-2xl text-center">
        <h2
          id="home-cta-heading"
          className="mb-6 px-1 text-[1.375rem] font-extrabold leading-tight text-heading sm:px-0 sm:text-3xl md:text-4xl"
        >
          {t("home.homeCtaTitle")}
        </h2>
        <Link
          to="/create/language"
          className="inline-flex w-full max-w-sm justify-center rounded-2xl bg-brandOrange px-6 py-3 text-base font-semibold text-white shadow-card transition hover:bg-orange-500 hover:shadow-glow focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 sm:w-auto sm:max-w-none sm:px-8 sm:text-lg"
        >
          {t("home.startYourBook")}
        </Link>
      </div>
    </section>
  );
};

export default HomeCTA;
